const ABSOLUTE_URL_RE = /^https?:\/\//i;

/**
 * Normalizes a CMS-provided path for use as an `href`.
 * - `http(s)://...` is returned unchanged.
 * - Relative paths get a single leading `/`.
 */
export function normalizeHrefPath(value: string | null | undefined): string | null {
    const trimmed = value?.trim();
    if (!trimmed) {
        return null;
    }
    if (ABSOLUTE_URL_RE.test(trimmed)) {
        return trimmed;
    }
    return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
}
